import { CSSProperties } from 'react'

import { SxProps } from '@mui/material'

import theme from '../../shared/styles/themes/default.theme'

export default {
  container: {
    display: 'flex',
    gap: theme.spacing(2),
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    minHeight: '100vh',
    paddingBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      gap: 0
    }
  },

  stepHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(10),
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(4)
    }
  },

  title: {
    textAlign: 'left',
    fontWeight: theme.typography.fontWeightBold
  } as CSSProperties,

  subtitle: {
    textAlign: 'left',
    color: theme.palette.text.secondary
  },

  content: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
    paddingBottom: theme.spacing(5),
    flexGrow: 1,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
      paddingRight: 0
    }
  } as SxProps,

  stepContent: {
    flexDirection: 'column',
    display: 'flex',
    textAlign: 'left',
    alignItems: 'center',
    justifyContent: 'center'
  },

  emptyStateContainer: {
    padding: theme.spacing(5, 10),
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(5, 0)
    }
  },

  submitButton: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      fontWeight: theme.typography.fontWeightBold
    }
  },

  addItemsContainer: {
    backgroundColor: theme.palette.background.default,
    width: '100%',
    borderRadius: theme.shape.borderRadius / 4,
    padding: theme.spacing(4),
    boxShadow: theme.shadows[3]
  } as CSSProperties,

  addAnotherItemButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    height: 48,
    borderRadius: 1,
    border: `1px solid ${theme.palette.primary.main}`,
    cursor: 'pointer',
    backgroundColor: 'transparent',
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.main}0D`
    }
  } as SxProps,

  addAnotherItemButtonDisabled: {
    borderColor: theme.palette.grey[300],
    cursor: 'not-allowed',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  } as SxProps,

  addAnotherItemText: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: 600
  } as SxProps,

  addAnotherItemTextDisabled: {
    color: theme.palette.grey[400]
  } as SxProps,

  overviewContainer: {
    [theme.breakpoints.down('md')]: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.appBar,
      backgroundColor: theme.palette.background.default,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(4),
      boxShadow: '0px -2px 4px rgba(0,0,0,0.32)'
    }
  } as SxProps,

  overviewWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  } as SxProps,

  continueButton: {
    [theme.breakpoints.down('md')]: {
      fontWeight: theme.typography.fontWeightBold
    }
  } as SxProps,

  divider: {
    [theme.breakpoints.down('md')]: {
      backgroundColor: theme.palette.divider,
      marginY: theme.spacing(0.5),
      marginX: theme.spacing(3)
    }
  },

  disclaimerAlert: {
    marginTop: theme.spacing(2),
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'left'
  },

  alertContainer: {
    width: '100%',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },

  customsErrorAlert: {
    marginBottom: theme.spacing(2)
  },

  paymentFailureAlert: {
    marginBottom: theme.spacing(2)
  },

  itemsStepContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%'
  } as SxProps,

  itemsStepInnerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  } as SxProps,

  addAnotherItemIcon: {
    color: theme.palette.primary.main,
    fontSize: 20
  } as SxProps,

  addAnotherItemIconDisabled: {
    color: theme.palette.grey[400],
    fontSize: 20
  } as SxProps,

  uspsDivider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  } as SxProps,

  paymentDetailsWrapper: {
    '& #payment-details': {
      height: 'auto !important'
    }
  } as SxProps,

  mobileSubmitButtonWrapper: {
    marginTop: theme.spacing(3),
    display: { xs: 'block', md: 'none' }
  } as SxProps,

  desktopSubmitButtonWrapper: {
    marginTop: theme.spacing(3)
  } as SxProps,

  desktopOrderSummaryColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  } as SxProps
}
